// extracted by mini-css-extract-plugin
module.exports = {"articleCategory":"ArticleCategory_articleCategory__4oz4g","articleCategoryActive":"ArticleCategory_articleCategoryActive__B6bAd"};